import { Alert, Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const EXAMPLE_PORTFOLIO_ID = '54f9b594-5a84-4fad-abfc-740aaa7892b6';
const EXAMPLE_APP_ID = 'eb8eb6aa-7eba-483b-a801-0c345c96fb76';

/**
 * Shared Polaris application-ID guidance used by the onboarding wizard and
 * Project Settings → Connections. Shows where the UUID lives in the Polaris
 * browser URL (the `portfolio-items` segment — visually highlighted in the
 * rendered example) and notes that either the UUID or the full URL can be
 * pasted into the input.
 */
export default function PolarisAppIdInstructions() {
  const { t } = useTranslation();
  return (
    <Alert
      severity="info"
      variant="outlined"
      sx={{ mb: 1.5, '& .MuiAlert-message': { fontSize: '0.8rem', width: '100%' } }}
    >
      <Box component="ol" sx={{ m: 0, pl: 2, '& li': { mb: 0.25 } }}>
        <li>{t('onboarding.form.polarisStep1')}</li>
        <li>{t('onboarding.form.polarisStep2')}</li>
        <li>{t('onboarding.form.polarisStep3')}</li>
      </Box>
      <Box
        component="code"
        sx={{
          display: 'block',
          mt: 1,
          p: 1,
          borderRadius: 1,
          bgcolor: 'action.hover',
          fontSize: 11,
          wordBreak: 'break-all',
        }}
      >
        https://polaris.blackduck.com/portfolio/portfolios/
        <Box component="span" sx={{ color: 'text.disabled' }}>
          {EXAMPLE_PORTFOLIO_ID}
        </Box>
        /portfolio-items/
        <Box
          component="span"
          sx={{ fontWeight: 700, color: 'primary.main', bgcolor: 'action.selected', px: 0.5, borderRadius: 0.5 }}
        >
          {EXAMPLE_APP_ID}
        </Box>
        /projects
      </Box>
      <Typography sx={{ fontSize: 11, color: 'text.secondary', mt: 0.75 }}>
        {t('onboarding.form.polarisUrlCaption')}
      </Typography>
    </Alert>
  );
}
